/**
 * Module: gallery
 * Handle story gallery functionality
 */

import Siema from 'siema';

var slides_selector = '.js-gallery-slides',
    nav_selector = '.js-gallery-nav',
    slide_selector = '.js-gallery-slide',
    prev_selector = '.js-gallery-prev',
    next_selector = '.js-gallery-next';

function init() {
    if( 1 < $( slide_selector ).length ) {
        const gallery = new Siema({
            selector: slides_selector
        });
    
        // Initialize navigation
        $( nav_selector ).addClass('js-active');
        $( prev_selector ).on('click', () => gallery.prev() );
        $( next_selector ).on('click', () => gallery.next() );
    }
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
    init: init
};


// WEBPACK FOOTER //
// ./scripts/components/gallery.js